/*
 *
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var Executor = /*#__PURE__*/function () {
  function Executor(block, entity, code) {
    (0, _classCallCheck2["default"])(this, Executor);
    this.scope = new Entry.Scope(block, this);
    this.isUpdateTime = 0;
    this.entity = entity;
    this.code = code;
    this._callStack = [];
    this.register = {};
    this.paused = false;
    this.parentExecutor = null;
    this.valueMap = {};
    this.valueState = {};
    this.id = Entry.Utils.generateId();
  }
  return (0, _createClass2["default"])(Executor, [{
    key: "execute",
    value: function execute(isFromOrigin) {
      var _this = this;
      if (Entry.isTurbo && !this.isUpdateTime) {
        this.isUpdateTime = performance.now();
      }
      if (this.isEnd()) {
        return;
      }
      var executedBlocks = [];
      var promises = [];
      if (isFromOrigin) {
        Entry.callStackLength = 0;
      }
      var entity = this.entity;
      var isOffline = window.location.href.indexOf('file://') === 0;
      var _loop = function _loop() {
          var returnVal = null;
          executedBlocks.push(_this.scope.block);
          try {
            var schema = _this.scope.block.getSchema();
            if (schema["class"] === 'ai_learning' && isOffline) {
              throw new Entry.Utils.OfflineError();
            }
            if (schema && Entry.skeleton[schema.skeleton].executable) {
              Entry.dispatchEvent('blockExecute', _this.scope.block && _this.scope.block.view);
              returnVal = _this.scope.run(entity);
              _this.scope.key = Entry.generateHash();
            }
          } catch (e) {
            if (e.name === 'AsyncError') {
              returnVal = Entry.STATIC.BREAK;
            } else if (e.name === 'IncompatibleError') {
              Entry.Utils.stopProjectWithToast(_this.scope, 'IncompatibleError', e);
            } else if (e.name === 'OfflineError') {
              Entry.Utils.stopProjectWithToast(_this.scope, 'OfflineError', e);
            } else if (_this.isFuncExecutor) {
              Entry.Utils.stopProjectWithToast(_this.parentScope, undefined, e);
            } else if (e.name === 'RangeError') {
              Entry.toast.alert(Lang.Workspace.RecursiveCallWarningTitle, Lang.Workspace.RecursiveCallWarningContent);
              Entry.Utils.stopProjectWithToast(_this.scope, undefined, e);
            } else {
              Entry.Utils.stopProjectWithToast(_this.scope, undefined, e);
            }
          }

          //executor can be ended after block function call
          if (_this.isEnd()) {
            return {
              v: executedBlocks
            };
          }
          if (returnVal instanceof Promise) {
            promises.push(returnVal);
            _this.paused = true;
            returnVal.then(function (returnVal) {
              _this.valueMap = {};
              _this.valueState = {};
              _this.paused = false;
              if (returnVal === Entry.STATIC.CONTINUE || returnVal === _this.scope) {
                return;
              }
              if (_this.scope.block && Entry.engine.isState('run')) {
                _this.scope = new Entry.Scope(_this.scope.block.getNextBlock(), _this);
              }
              if (_this.scope.block === null && _this._callStack.length) {
                var oldScope = _this.scope;
                _this.scope = _this._callStack.pop();
                if (_this.scope.isLooped !== oldScope.isLooped) {
                  _this.isLooped = true;
                }
              }
            })["catch"](function (e) {
              _this.paused = false;
              if (e.name === 'AsyncError') {
                returnVal = Entry.STATIC.BREAK;
              } else if (e.name === 'IncompatibleError') {
                Entry.Utils.stopProjectWithToast(_this.scope, 'IncompatibleError', e);
              } else if (_this.isFuncExecutor) {
                //function executor
                Entry.Utils.stopProjectWithToast(_this.parentScope, undefined, e);
              } else if (e.name === 'RangeError') {
                Entry.toast.alert(Lang.Workspace.RecursiveCallWarningTitle, Lang.Workspace.RecursiveCallWarningContent);
                Entry.Utils.stopProjectWithToast(_this.scope, undefined, e);
              } else {
                Entry.Utils.stopProjectWithToast(_this.scope, undefined, e);
              }
            });
            return 0; // break
          } else if (returnVal === undefined || returnVal === null || returnVal === Entry.STATIC.PASS) {
            _this.scope = new Entry.Scope(_this.scope.block.getNextBlock(), _this);
            _this.valueMap = {};
            _this.valueState = {};
            if (_this.scope.block === null) {
              if (_this._callStack.length) {
                var oldScope = _this.scope;
                _this.scope = _this._callStack.pop();
                if (_this.scope.isLooped !== oldScope.isLooped) {
                  _this.isLooped = true;
                  return 0; // break
                }
              } else {
                return 0; // break
              }
            }
          } else if (returnVal === Entry.STATIC.CONTINUE) {
            _this.valueMap = {};
            _this.valueState = {};
          } else if (returnVal === _this.scope) {
            _this.valueMap = {};
            _this.valueState = {};
            return 0; // break
          } else if (returnVal === Entry.STATIC.BREAK) {
            return 0; // break
          }
        },
        _ret;
      while (true) {
        _ret = _loop();
        if (_ret === 0) break;
        if (_ret) return _ret.v;
      }
      return {
        promises: promises,
        blocks: executedBlocks
      };
    }
  }, {
    key: "checkExecutorError",
    value: function checkExecutorError(error) {
      if (error.name === 'AsyncError') {
        return Entry.STATIC.BREAK;
      } else if (this.isFuncExecutor) {
        throw error;
      } else {
        Entry.Utils.stopProjectWithToast(this.scope, undefined, error);
      }
    }
  }, {
    key: "checkExecutorResult",
    value: function checkExecutorResult(returnVal) {
      if (returnVal === undefined || returnVal === null || returnVal === Entry.STATIC.PASS) {
        this.scope = new Entry.Scope(this.scope.block.getNextBlock(), this);
        this.valueMap = {};
        this.valueState = {};
        if (this.scope.block === null) {
          if (this._callStack.length) {
            var oldScope = this.scope;
            this.scope = this._callStack.pop();
            if (this.scope.isLooped !== oldScope.isLooped) {
              this.isLooped = true;
              return true;
            }
          } else {
            return true;
          }
        }
      } else if (returnVal === Entry.STATIC.CONTINUE) {
        this.valueMap = {};
        this.valueState = {};
      } else if (returnVal === this.scope) {
        this.valueMap = {};
        this.valueState = {};
        return true;
      } else if (returnVal === Entry.STATIC.BREAK) {
        return true;
      }
    }
  }, {
    key: "stepInto",
    value: function stepInto(thread) {
      if (!(thread instanceof Entry.Thread)) {
        console.error('Must step in to thread');
      }
      var block = thread.getFirstBlock();
      if (!block) {
        return Entry.STATIC.BREAK;
      }
      this._callStack.push(this.scope);
      this.scope = new Entry.Scope(block, this);
      return Entry.STATIC.CONTINUE;
    }
  }, {
    key: "break",
    value: function _break() {
      if (this._callStack.length) {
        this.scope = this._callStack.pop();
      }
      return Entry.STATIC.PASS;
    }
  }, {
    key: "breakLoop",
    value: function breakLoop() {
      if (this._callStack.length) {
        this.scope = this._callStack.pop();
      }
      while (this._callStack.length) {
        var schema = Entry.block[this.scope.block.type];
        if (schema["class"] === 'repeat') {
          break;
        }
        this.scope = this._callStack.pop();
      }
      return Entry.STATIC.PASS;
    }
  }, {
    key: "continueLoop",
    value: function continueLoop() {
      if (this._callStack.length) {
        this.scope = this._callStack.pop();
      } else {
        return Entry.STATIC.PASS;
      }
      while (this._callStack.length) {
        var schema = Entry.block[this.scope.block.type];
        if (schema["class"] === 'repeat') {
          break;
        }
        this.scope = this._callStack.pop();
      }
      return Entry.STATIC.BREAK;
    }
  }, {
    key: "end",
    value: function end() {
      Entry.dispatchEvent('blockExecuteEnd', this.scope.block && this.scope.block.view);
      this.scope.block = null;
    }
  }, {
    key: "isPause",
    value: function isPause() {
      return this.paused;
    }
  }, {
    key: "isEnd",
    value: function isEnd() {
      return this.scope.block === null;
    }
  }]);
}();
Entry.Executor = Executor;